"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MfaSelecteurDate = void 0;

var _react = _interopRequireWildcard(require("react"));

var _pickers = require("@material-ui/pickers");

var _MfaEnveloppe = require("./MfaEnveloppe");

var _format = _interopRequireDefault(require("date-fns/format"));

var _fr = _interopRequireDefault(require("date-fns/locale/fr"));

var _dateFns = _interopRequireDefault(require("@date-io/date-fns"));

var _moment = _interopRequireDefault(require("moment"));

var _utilitaires = require("../utils/utilitaires");

require("../css/mfa-enveloppe.css");

require("../css/mfa-selecteur-date.css");

var _MfaChampProprietes = require("../commun/MfaChampProprietes");

var _utilitaires2 = require("../utils/utilitaires.date");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var MfaSelecteurDate = /*#__PURE__*/function (_Component) {
  _inherits(MfaSelecteurDate, _Component);

  var _super = _createSuper(MfaSelecteurDate);

  function MfaSelecteurDate(props) {
    var _this;

    _classCallCheck(this, MfaSelecteurDate);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "id", void 0);

    _this.id = (0, _utilitaires.estDefini)(_this.props.id) ? _this.props.id : (0, _utilitaires.guid)();
    _this.state = {
      formatDate: (0, _utilitaires.estDefini)(_this.props.format) ? _this.props.format : "yyyy-MM-dd"
    };
    return _this;
  }

  _createClass(MfaSelecteurDate, [{
    key: "messageMinimumDate",
    value: function messageMinimumDate(messageMinDate) {
      if ((0, _utilitaires.estDefini)(this.props.minDate)) {
        return "La date doit être supérieure ou égale à " + (0, _format.default)(this.props.minDate, this.state.formatDate);
      }

      return messageMinDate;
    }
  }, {
    key: "messageMaximumDate",
    value: function messageMaximumDate(messageMaxDate) {
      var currentDate = new Date();

      if (this.props.disableFuture && (0, _utilitaires.estDefini)(this.props.maxDate)) {
        if (new Date() > new Date(this.props.maxDate)) {
          currentDate = this.props.maxDate;
        }

        return "La date doit être inférieure ou égale à " + (0, _format.default)(currentDate, this.state.formatDate);
      } else {
        if (this.props.disableFuture) {
          return "La date doit être inférieure ou égale à " + (0, _format.default)(new Date(), this.state.formatDate);
        }

        if ((0, _utilitaires.estDefini)(this.props.maxDate)) {
          return "La date doit être inférieure ou égale à " + (0, _format.default)(this.props.maxDate, this.state.formatDate);
        }
      }

      return messageMaxDate;
    }
  }, {
    key: "obtenirDate",
    value: function obtenirDate() {
      var _this$props = this.props,
          valeur = _this$props.valeur,
          valeurInitiale = _this$props.valeurInitiale;
      return (0, _utilitaires.estDefini)(valeur) ? valeur : (0, _utilitaires.estDefini)(valeurInitiale) ? valeurInitiale : null;
    }
  }, {
    key: "obtenirDateFormattee",
    value: function obtenirDateFormattee() {
      var date = this.obtenirDate();

      if (!(0, _utilitaires.estDefini)(date) || !(0, _utilitaires2.estDateValide)(date)) {
        return '';
      }

      return (0, _utilitaires2.formatterDate)(new Date(date));
    }
  }, {
    key: "render",
    value: function render() {
      var lectureSeule = this.props.lectureSeule;

      if ((0, _utilitaires.estDefini)(lectureSeule) && lectureSeule === true) {
        return /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, {
          className: this.props.className,
          estObligatoire: this.props.estObligatoire,
          etiquette: this.props.etiquette,
          idChamp: this.id,
          messageErreur: this.props.messageErreur,
          precision: this.props.precision,
          taille: this.props.taille
        }, this.obtenirDateFormattee());
      }

      var labelInvalide = "La date est non valide";
      var messageDateInvalide = "Le format de date est non valide";
      var messageMinDate = this.messageMinimumDate("La date ne doit pas être avant à la date minimale");
      var messageMaxDate = this.messageMaximumDate("La date ne doit pas être après à la date maximale");
      var exemple = (0, _utilitaires.estDefini)(this.props.exemple) ? this.props.exemple : this.props.placeholder;
      var surChangement = (0, _utilitaires.estDefini)(this.props.surChangement) ? this.props.surChangement : this.props.onChange;
      var boutonAujourdhui = (0, _utilitaires.elementEstEgalA)(this.props.boutonAujourdhui, true);
      var properties = this.obtenirPropsFiltrees();
      properties.variant = "dialog";
      properties.cancelLabel = "Annuler";
      properties.todayLabel = "Aujourd'hui";
      properties.autoOk = false;

      if ((0, _utilitaires.estDefini)(surChangement)) {
        properties.onChange = surChangement;
      }

      properties.format = this.state.formatDate;
      properties.showTodayButton = boutonAujourdhui;

      if ((0, _utilitaires.elementEstEgalA)(this.props.selectionAutomatique, true)) {
        properties.autoOk = true;
        properties.variant = "inline";
        delete properties.cancelLabel;
        delete properties.showTodayButton;
        delete properties.todayLabel;
      }

      if (this.afficherHeureSeulement()) {
        labelInvalide = "L'heure est non valide";
      }

      if ((0, _utilitaires.nestPasNulOuVide)(this.props.valeur)) {
        var valeur = this.props.valeur;
        properties.value = this.props.valeur;

        if ((0, _utilitaires.elementEstEgalA)(this.props.convertirUTC, true) && (0, _utilitaires.nestPasNulOuVide)(valeur)) {
          valeur = _moment.default.parseZone(valeur).utc(true).format();
        }

        properties.value = valeur;
      } // MES-1222 (Début)
      else {
          if (this.props.valeur === undefined) {
            if ((0, _utilitaires.nestPasNulOuVide)(this.props.valeurInitiale)) {
              properties.value = this.props.valeurInitiale;
            } else {
              properties.value = null;
            }
          } else {
            properties.value = null;
          }
        } // MES-1222 (Fin)


      var surPerteDeFocus = this.props.surPerteDeFocus;

      if ((0, _utilitaires.estDefini)(surPerteDeFocus)) {
        properties.onBlur = surPerteDeFocus;
        properties.onAccept = surPerteDeFocus;
      }

      return /*#__PURE__*/_react.default.createElement(_MfaEnveloppe.MfaEnveloppe, {
        estObligatoire: this.props.estObligatoire,
        etiquette: this.props.etiquette,
        idChamp: this.id,
        messageErreur: this.props.messageErreur,
        precision: this.props.precision,
        taille: this.obtenirTaille()
      }, this.afficherDateHeure() && /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-selecteurdate"
      }, /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default,
        locale: _fr.default
      }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDateTimePicker, _extends({}, properties, {
        ampm: false,
        placeholder: (0, _utilitaires.nestPasNulOuVide)(exemple) ? exemple : "AAAA-MM-JJ HH:mm",
        disabled: (0, _utilitaires.nestPasNulOuVide)(this.props.desactive) ? this.props.desactive : false,
        inputVariant: (0, _utilitaires.estDefini)(this.props.inputVariant) ? this.props.inputVariant : "outlined",
        InputAdornmentProps: (0, _utilitaires.estDefini)(this.props.InputAdornmentProps) ? {
          position: "start"
        } : {
          position: "end"
        },
        invalidLabel: (0, _utilitaires.estDefini)(this.props.invalidLabel) ? this.props.invalidLabel : messageDateInvalide,
        invalidDateMessage: (0, _utilitaires.estDefini)(this.props.invalidDateMessage) ? this.props.invalidDateMessage : labelInvalide,
        minDateMessage: (0, _utilitaires.estDefini)(this.props.minDateMessage) ? this.props.minDateMessage : messageMinDate,
        maxDateMessage: (0, _utilitaires.estDefini)(this.props.maxDateMessage) ? this.props.maxDateMessage : messageMaxDate
      })))), this.afficherDateSeulement() && /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-selecteurdate"
      }, /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default,
        locale: _fr.default
      }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardDatePicker, _extends({}, properties, {
        placeholder: (0, _utilitaires.nestPasNulOuVide)(exemple) ? exemple : "AAAA-MM-JJ",
        disabled: (0, _utilitaires.nestPasNulOuVide)(this.props.desactive) ? this.props.desactive : false,
        inputVariant: (0, _utilitaires.estDefini)(this.props.inputVariant) ? this.props.inputVariant : "outlined",
        InputAdornmentProps: (0, _utilitaires.estDefini)(this.props.InputAdornmentProps) ? {
          position: "start"
        } : {
          position: "end"
        },
        invalidLabel: (0, _utilitaires.estDefini)(this.props.invalidLabel) ? this.props.invalidLabel : messageDateInvalide,
        invalidDateMessage: (0, _utilitaires.estDefini)(this.props.invalidDateMessage) ? this.props.invalidDateMessage : labelInvalide,
        minDateMessage: (0, _utilitaires.estDefini)(this.props.minDateMessage) ? this.props.minDateMessage : messageMinDate,
        maxDateMessage: (0, _utilitaires.estDefini)(this.props.maxDateMessage) ? this.props.maxDateMessage : messageMaxDate
      })))), this.afficherHeureSeulement() && /*#__PURE__*/_react.default.createElement("div", {
        className: "mfa-selecteurdate"
      }, /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
        utils: _dateFns.default,
        locale: _fr.default
      }, /*#__PURE__*/_react.default.createElement(_pickers.KeyboardTimePicker, _extends({}, properties, {
        ampm: false,
        placeholder: (0, _utilitaires.nestPasNulOuVide)(exemple) ? exemple : "HH:mm",
        disabled: (0, _utilitaires.nestPasNulOuVide)(this.props.desactive) ? this.props.desactive : false,
        inputVariant: (0, _utilitaires.estDefini)(this.props.inputVariant) ? this.props.inputVariant : "outlined",
        InputAdornmentProps: (0, _utilitaires.estDefini)(this.props.InputAdornmentProps) ? {
          position: "start"
        } : {
          position: "end"
        },
        invalidLabel: (0, _utilitaires.estDefini)(this.props.invalidLabel) ? this.props.invalidLabel : messageDateInvalide,
        invalidDateMessage: (0, _utilitaires.estDefini)(this.props.invalidDateMessage) ? this.props.invalidDateMessage : labelInvalide,
        minDateMessage: (0, _utilitaires.estDefini)(this.props.minDateMessage) ? this.props.minDateMessage : messageMinDate,
        maxDateMessage: (0, _utilitaires.estDefini)(this.props.maxDateMessage) ? this.props.maxDateMessage : messageMaxDate
      })))));
    }
  }, {
    key: "afficherDateHeure",
    value: function afficherDateHeure() {
      if ((0, _utilitaires.elementEstEgalA)(this.props.afficherDateHeure, true) && !(0, _utilitaires.elementEstEgalA)(this.props.afficherHeureSeulement, true)) {
        return true;
      }

      return false;
    }
  }, {
    key: "afficherDateSeulement",
    value: function afficherDateSeulement() {
      if ((0, _utilitaires.elementEstEgalA)(this.props.afficherDateHeure, true) && (0, _utilitaires.elementEstEgalA)(this.props.afficherHeureSeulement, true)) {
        return true;
      }

      if ((0, _utilitaires.elementEstEgalA)(this.props.afficherDateHeure, true) || (0, _utilitaires.elementEstEgalA)(this.props.afficherHeureSeulement, true)) {
        return false;
      }

      return true;
    }
  }, {
    key: "afficherHeureSeulement",
    value: function afficherHeureSeulement() {
      if (!(0, _utilitaires.elementEstEgalA)(this.props.afficherDateHeure, true) && (0, _utilitaires.elementEstEgalA)(this.props.afficherHeureSeulement, true)) {
        return true;
      }

      return false;
    }
  }, {
    key: "obtenirTaille",
    value: function obtenirTaille() {
      if ((0, _utilitaires.nestPasNulOuVide)(this.props.taille)) {
        if (this.props.taille === 'xl') {
          return 'xl';
        }

        if (this.props.taille === 'sm' || this.props.taille === 'md') {
          return 'md';
        }
      }

      return 'lg';
    }
  }, {
    key: "obtenirPropsFiltrees",
    value: function obtenirPropsFiltrees() {
      return (0, _utilitaires.filtrerProprietesObjet)(this.props, _MfaChampProprietes.MfaChampProprietes, ['estObligatoire', 'etiquette', 'exemple', 'idChamp', 'precision', 'taille', 'afficherDateHeure', 'afficherHeureSeulement', 'selectionAutomatique', 'boutonAujourdhui', 'surChangement', 'conserverUTC', 'desactive', 'valeur', 'etiquetteAnnulee', 'etiquetteJour', 'affBoutonJour', 'etiquetteAnnulee', 'etiquetteJour']);
    }
  }]);

  return MfaSelecteurDate;
}(_react.Component);

exports.MfaSelecteurDate = MfaSelecteurDate;